import { Paper, Typography } from '@mui/material';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';
import { FunctionComponent } from 'react';

export const GoodCatalogueTree: FunctionComponent<{
  goodCatalogue: any,
  handleItemSelectionToggle: (event: React.SyntheticEvent | null, itemId: string, isSelected: boolean,) => void,
  selectedCatalogueItemId: string
}> = ({
  goodCatalogue,
  handleItemSelectionToggle,
  selectedCatalogueItemId,
}) => {
    return (
      <Paper variant='outlined' sx={{ p: 2, borderRadius: '10px', height: '100%' }}>
        <Typography variant='caption' sx={{ display: 'block', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: 'text.secondary', mb: 1 }}>
          Categories
        </Typography>
        <SimpleTreeView
          onItemSelectionToggle={handleItemSelectionToggle}
          selectedItems={selectedCatalogueItemId ? selectedCatalogueItemId : ''}
          sx={{
            // Room to breathe per row; the selected row picks up the brand tint.
            '& .MuiTreeItem-content': { py: 0.75, borderRadius: '8px' },
            '& .MuiTreeItem-content.Mui-selected, & .MuiTreeItem-content.Mui-selected.Mui-focused': {
              backgroundColor: 'secondary.main',
            },
          }}
        >
          {
            goodCatalogue.map((category: any) => {
              return (
                <TreeItem label={category.label} itemId={category.id} key={category.id}>
                  {category.children && category.children.map((subCategoryOne: any) => {
                    return (
                      <TreeItem label={subCategoryOne.label} itemId={subCategoryOne.id} key={subCategoryOne.id}>
                        {subCategoryOne.children && subCategoryOne.children.map((subCategoryTwo: any) => {
                          return (
                            <TreeItem label={subCategoryTwo.label} itemId={subCategoryTwo.id} key={subCategoryTwo.id} />
                          );
                        })}
                      </TreeItem>
                    );
                  })}
                </TreeItem>
              );
            })
          }
        </SimpleTreeView>
      </Paper>
    )
  };
